import React from 'react'
import { FormContextProvider } from '../../../../../context/formContext'
import { ElegibilidadProvider } from '../../../../../context/ElegibilidadContext'
import Toast from '../../../../../components/Toast/Toast'
import ViewFormsElegibilidad from './ViewFormsElegibilidad'

const FormsDraftWrapperElegibilidad = () => {
  return (
    <ElegibilidadProvider>
      <FormContextProvider>
        <Toast />
        <ViewFormsElegibilidad />
      </FormContextProvider>
    </ElegibilidadProvider>
  )
}

export default FormsDraftWrapperElegibilidad
